// ----------------------------------------------------------------------
// <copyright file="Izenda.ConnectionDetail.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * ConnectionDetail component
 */
!(function() {
  var connect = require('share/enhancers/Izenda.Connect');
  var classnames = require('classnames');
  var EventsUtils = require('EventUtils');

  var React = require('react');
  var ReactDOM = require('react-dom');
  var Panel = require('share/components/controls/Izenda.Panel');
  var Label = require('share/components/controls/Izenda.Label');
  var Span = require('share/components/controls/Izenda.Span');
  var FormGroup = require('share/components/controls/Izenda.FormGroup');
  var DropDown = require('share/components/controls/Izenda.DropDown');
  var Icon = require('share/components/controls/Izenda.Icon');
  var Button = require('share/components/controls/Izenda.Button');
  var ConnectionStringBuilder = require('share/components/controls/connectionStringBuilder/Izenda.ConnectionStringBuilder');
  var constants = require('logic/data/Izenda.ConnectionConstants');

  var Validator = require('share/components/hoc/Izenda.Validator');
  var ValidatableInput = Validator()(require('share/components/controls/Izenda.Input'));
  var ValidatableSecuredInput = Validator()(require('share/components/controls/Izenda.SecuredInput'));
  const { merge, partial, findLast } = require('lodash/fp');

  var ConnectionDetail = React.createClass({
    propTypes: {
      store: React.PropTypes.object.isRequired,
      item: React.PropTypes.object.isRequired,
      dbTypeList: React.PropTypes.object.isRequired
    },
    componentWillReceiveProps: function(nextProps) {
      var store = nextProps.store;
      var loader = nextProps.loader;
      // Only load data when showing different connection.
      if (this.props.item.id !== nextProps.item.id) {
        loader.startLoading();
        store.load(nextProps.item.id).finally(loader.endLoading.bind(loader));
      }
    },
    render: function() {
      var store = this.props.store;
      var detail = this.props.item;
      var dbTypeList = this.props.dbTypeList;
      var localization = this.props.localization;
      var disabled = !detail.visible;

      var notifyChange = EventsUtils.notifyChange;
      var notify = EventsUtils.notify;

      var connStringVals = merge(
        constants.CONNECTION_STRING_CONSTRAINT,
        {
          action: function() {
            return store.validateConnection.bind(store);
          }
        },
        {}
      );
      var inputClasses = classnames('form-control', { 'izenda-ConnectringString-input': detail.isSecured });

      return (
        <Panel className="connection-string-validation-container">
          <Label>{localization.getText('CONNECTION_LABEL_DATABASE_NAME')}</Label>

          <FormGroup>
            <ValidatableInput
              field="name"
              validations={constants.DATABASE_NAME_CONSTRAINT}
              className="form-control"
              onChange={notifyChange(detail.setName.bind(detail), EventsUtils.INPUT)}
              value={detail.name}
              disabled={disabled}
            />
          </FormGroup>

          <div className="row">
            <div className="col-md-4">
              <FormGroup>
                <Label className="validation required">
                  {localization.getText('CONNECTION_LABEL_DATA_SERVER_TYPE')}
                </Label>

                <DropDown
                  disabled={disabled}
                  labelField="name"
                  valueField="id"
                  options={dbTypeList}
                  value={detail.serverTypeId}
                  onChange={notifyChange(detail.setServerTypeId.bind(detail), EventsUtils.DROPDOWN)}
                  ref="dbServerType"
                />
              </FormGroup>
            </div>

            <div className="col-md-8">
              <div className="row">
                <Label className="col-md-6 validation required">
                  {localization.getText('CONNECTION_LABEL_CONNECTION_STRING')}
                </Label>
                <div
                  disabled={disabled}
                  className="text-right u_paddingRight connection-string-builder"
                  onClick={this.showConnectionStringBuilder}
                >
                  <Span className="no-padding-left-right">
                    {localization.getText('CONNECTION_LABEL_CONNECTION_BUILDER')}
                  </Span>

                  <Icon className="icon-flash" />
                </div>
              </div>

              <div>
                <div className="u_inlineBlock u-posRelative izenda-ConnectringString-wrapper">
                  <ValidatableSecuredInput
                    className={inputClasses}
                    onReset={notify(partial(detail.setConnectionString.bind(detail), ''))}
                    onFocus={this.onResetConnectionString}
                    onChange={notifyChange(detail.setConnectionString.bind(detail), EventsUtils.INPUT)}
                    value={detail.securedConnectionString}
                    secure={detail.isSecured}
                    enabled={!disabled}
                    validations={connStringVals}
                    onValidated={this.onValidated}
                    field="connectionString"
                    maxLength="500"
                  />

                  {detail.isSecured ? (
                    <span className="u_inlineBlock u-posAbsolute icon-ok success-color valid-connection" />
                  ) : null}
                </div>

                <Button
                  label={localization.getText('COMMON_LABEL_TEST')}
                  onClick={this.props.onTestConnection}
                  disabled={disabled}
                  className="u_inlineBlock u_marginLeft pull-right"
                />
              </div>
            </div>
          </div>
        </Panel>
      );
    },

    onValidated: function(success) {
      this.props.item.isConnectionStringValid = success;
    },

    /**
     * [onResetConnectionString function]
     * is to reset connection string validation value
     */
    onResetConnectionString: function() {
      var detail = this.props.item;
      if (detail.isSecured || detail.isDirty) {
        this.props.validation.reset('connectionString');
      }
    },

    /**
     * Display Connection string builder popup that allows user to enter the
     * information of a connection string.
     * @param  {Object} e React-event object
     */
    showConnectionStringBuilder: function(e) {
      e.preventDefault();
      if (!this.props.item.visible === true) {
        return;
      }

      var applyConnectionString = function applyConnectionString(connectionString) {
        var item = this.props.store.item;
        item.setConnectionString(connectionString);
        return true;
      }.bind(this);

      var dbTypeList = this.props.dbTypeList;
      var serverTypeId = this.props.item.serverTypeId;
      var serverTypeName = findLast({ id: serverTypeId }, dbTypeList).name;

      return this.props.openPopup(ConnectionStringBuilder, {
        onOk: applyConnectionString.bind(this),
        serverType: serverTypeName
      });
    }
  });

  module.exports = connect()(ConnectionDetail);
})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/Connection/ConnectionConfig/ConnectionDetail/Izenda.ConnectionDetail.jsx